import { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography, Select, MenuItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { palette } from "../../theme/palette";
import { SECTION_SORT_TYPES, SORT_ORDERS } from "../../consts/sorters";

import { sectionsSorters } from "../../utils/sorters";

import {
  sortOrderSelector,
  sortTypeSelector,
} from "../../reducers/sorters/selectors";
import { setSortOrder, setSortType } from "../../reducers/sorters";

import { SortAscIcon, SortDescIcon, TickIcon } from "../Icons";
import { View } from "../View";

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    padding: "2px 10px",
  },
  text: {
    marginTop: "2px",
    fontSize: "12px",
    color: palette.white,
  },
  select: {
    marginLeft: "5px",
    marginRight: "auto",
    fontSize: "11px",
    backgroundColor: palette.sunburst,
    width: "135px",
    height: "17px",
    borderRadius: "4px",
    "& .MuiSelect-icon": {
      color: palette.typography.black.solid,
      transform: "rotate(90deg)",
    },
    "& .MuiPaper-root": {
      marginTop: "-25px",
      backgroundColor: palette.sunburst,
      width: "135px",
    },
    "& .MuiList-padding": {
      padding: "0px",
    },
    "& .Mui-selected": {
      backgroundColor: "transparent",
    },
    "& .MuiMenuItem-root": {
      fontSize: "11px",
    },
    "& .MuiListItem-gutters": {
      padding: "0px",
    },
  },
  selectOption: {
    display: "flex",
    paddingTop: "4px",
    maxWidth: "115px",
    height: "17px",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "12px",
  },
  selectOptionLabel: {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  tickIcon: {
    marginTop: "-2px",
    heigh: "10px",
    width: "10px",
    color: palette.typography.black.solid,
  },
  orderIcon: {
    height: "20px",
    width: "20px",
    cursor: "pointer",
  },
});

export const SectionSortBar = memo(() => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const sortOrder = useSelector(sortOrderSelector);
  const sortType = useSelector(sortTypeSelector);
  const styles = useStyles();

  useEffect(() => {
    if (sortType && !sectionsSorters[sortType])
      dispatch(setSortType(SECTION_SORT_TYPES.SECTION_NAME));
  }, [dispatch, sortType]);

  return (
    <View className={styles.container}>
      <Typography className={styles.text}>SORT BY:</Typography>
      <Select
        className={styles.select}
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        onChange={({ target }) => dispatch(setSortType(target.value))}
        value={sortType}
        defaultValue={SECTION_SORT_TYPES.SECTION_NAME}
        IconComponent={(props) => <ChevronRightIcon {...props} />}
        MenuProps={{
          disablePortal: true,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
        disableUnderline={true}
      >
        {Object.values(SECTION_SORT_TYPES).map((value) => {
          return (
            <MenuItem key={value} value={value}>
              <View className={styles.selectOption}>
                <View className={styles.selectOptionLabel}>{value}</View>
                {!isOpen || sortType !== value ? (
                  <View />
                ) : (
                  <TickIcon className={styles.tickIcon} />
                )}
              </View>
            </MenuItem>
          );
        })}
      </Select>
      {sortOrder === SORT_ORDERS.ASC ? (
        <SortAscIcon
          className={styles.orderIcon}
          fill={palette.typography.white.high}
          onClick={() => dispatch(setSortOrder(SORT_ORDERS.DESC))}
        />
      ) : (
        <SortDescIcon
          className={styles.orderIcon}
          fill={palette.typography.white.high}
          onClick={() => dispatch(setSortOrder(SORT_ORDERS.ASC))}
        />
      )}
    </View>
  );
});
